import React, { useEffect, useState } from 'react';
import { AlertDataType } from '../../components/react/alert_popup/types';
import classNames from 'classnames';
import { getArticles } from '../../news_search_react/services/news_search.service';
import { GENERIC_ERROR_MESSAGE } from '../../components/react/alert_popup/constants';
import AlertPopup from '../../components/react/alert_popup/alert_popup';
import TwoColumnsArticlesListBs5 from '../../../views/dual_visual_components/two_columns_articles_list_bs5/two_columns_articles_list_bs5';

interface Article {
  id: number;
  slug_and_id: string;
  title: string;
  thumbnail: string;
  teaser?: string;
}

const PAGE_SIZE = 4;

const ProSubscriberMoreProArticles: React.FC<{
  idsToExcludeFromRequest: number[];
  proMembershipAccessLevelId: number;
}> = ({ idsToExcludeFromRequest, proMembershipAccessLevelId }) => {
  const [excludedIds, setExcludedIds] = useState<number[]>(idsToExcludeFromRequest);
  const [articles, setArticles] = useState<Article[]>([]);
  const [pageNumber, setPageNumber] = useState<number>(0);
  const [alertData, setAlertData] = useState<AlertDataType | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showMoreProArticlesButton, setShowMoreProArticlesButton] = useState<boolean>(true);

  useEffect(() => {
    if (pageNumber === 0) {
      return;
    }

    setIsLoading(true);
    getArticles({
      query: [''],
      page: { size: PAGE_SIZE, number: pageNumber },
      filter: { exclude_ids: excludedIds, access_level_ids: [proMembershipAccessLevelId] },
    })
      .then((data) => {
        setShowMoreProArticlesButton(data.total > pageNumber * PAGE_SIZE);
        setArticles([...articles, ...data.data]);
        setExcludedIds([...excludedIds, ...data.data.map((article) => article.id)]);
      })
      .catch(() => {
        setAlertData({ type: 'error', message: GENERIC_ERROR_MESSAGE });
        setShowMoreProArticlesButton(false);
      })
      .finally(() => setIsLoading(false));
  }, [pageNumber]);

  const onMoreProArticlesClick = () => {
    setPageNumber(pageNumber + 1);
  };

  return (
    <>
      <AlertPopup alertData={alertData} setAlertData={setAlertData} />
      <TwoColumnsArticlesListBs5 list={articles} showColBorderOnDesktop={false} />
      {showMoreProArticlesButton && (
        <div className='row justify-content-center mt-35 mb-5'>
          <div className='col-auto'>
            <button
              disabled={isLoading}
              className={classNames('btn btn-lg btn-primary fw-normal', isLoading && 'loading')}
              onClick={onMoreProArticlesClick}
            >
              <i className='icon-plus-circle fal me-2' />
              More Pro Articles
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ProSubscriberMoreProArticles;
